import { MeQuery } from '../__generated__/graphql';

export type ChildrenPropType = {
  children: React.ReactNode;
};

export type UserData = NonNullable<MeQuery['me']>;

export enum VoteEnum {
  UpVote = 'UpVote',
  DownVote = 'DownVote',
  NoVote = 'NoVote',
}
